import React from 'react'

const EditBrand = () => {
  return (
    <div>EditBrand</div>
  )
}

export default EditBrand